<script>
import { Course } from '@/api'
import HeaderTabsContent from '@/views/Layouts/HeaderTabsContent'

export default {
  extends: HeaderTabsContent,
  computed: {
    service() {
      return Course
    },
    title() {
      return this.instance ? this.instance.name : 'Dodaj nowy kurs'
    },
    routes() {
      const params = this.$route.params
      return [
        {
          label: 'Szczegóły kursu',
          icon: 'laptop',
          to: `/admin/kursy/szczegoly/${params.courseId}/edytuj/`
        },
        {
          label: 'Kalendarz',
          icon: 'calendar',
          to: `/admin/kursy/szczegoly/${params.courseId}/kalendarz/`
        },
        {
          label: 'Materiały dydaktyczne',
          icon: 'folder-open',
          to: `/admin/kursy/szczegoly/${params.courseId}/materialy-dydaktyczne/`
        },
        {
          label: 'Informacje o lektorze',
          icon: 'user',
          to: `/admin/kursy/szczegoly/${params.courseId}/lektor/`
        },
        {
          label: 'Historia zajęć',
          icon: 'history',
          to: `/admin/kursy/szczegoly/${params.courseId}/historia-zajec/`
        }
      ]
    },
    params() {
      return this.$route.params.courseId
    }
  }
}
</script>
